import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import styles from './StartNoteScribe.module.css';
import { alertActions, noteActions } from '_actions'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CommonButton } from '_components';

class PatientHomeAdmissionStartNoteScribe extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            transfer: 'select',
            prepopulate: 'select'
        };
    }

    handleDDLChange(event){
        this.setState({selectValue: event.target.value});
    }

    startScribeNote() {

        if (this.state.selectValue && this.state.selectValue !== 1) {
            this.props.startNoteScribe(this.props.epno, this.state.selectValue) 
        }
    }

    render() {
        return (
            <div className={styles.option_table}>
                {this.props.supvOptions?.length > 0 ? (<div className={styles.option_wrapper}>
                    <div className={styles.prompt}>
                        Please select the note owner
                    </div>
                    <div className={styles.row}>
                        <span className={this.props.islicensed ? styles.body_left_col1 : styles.body_left_col1_req}>Scribe for: </span>
                        <span className={styles.body_left_col2}>
                            <select
                                value={this.state.selectValue} 
                                onChange={(event) => this.handleDDLChange(event)}
                            >
                                
                            <option key={-1} value={-1}></option>
                            {this.props.supvOptions && Object.keys(this.props.supvOptions)
                            .map(id => {
                            const option = this.props.supvOptions[id];
                            return (
                                <option key={option.id} value={option.URNO}>{option.value}</option>
                            );
                        })
                        }
                        </select>
                        <div className={styles.divider}/>                    
                        <CommonButton title={'Start Note'} onClick={() => this.startScribeNote()} className={styles.startNoteButton} >
                            <FontAwesomeIcon icon={faArrowRight} transform="shrink-6" color="white" />
                        </CommonButton> 
                        </span>
                    </div>
                </div>
               ):(<span className={styles.supervisorNote}>There aren't any supervisors assigned to this scribe at the moment, as supervisor roles haven't been established for them yet.</span>)}
                 <div></div>
                <span></span>
            </div>

        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearOptions: bindActionCreators(noteActions.startNoteEvalOptionsClear, dispatch),
        startNoteScribe: bindActionCreators(noteActions.startNoteScribe, dispatch),
        alertError: bindActionCreators(alertActions.error, dispatch)
    };
}


function mapStateToProps(state, ownprops) {
    let epno = ownprops.id
    let supvOptions = state.entities.admissions[epno].therapists ?  Object.keys(state.entities.admissions[epno].therapists)
    .sort((a, b) => {
        let val = state.entities.admissions[epno].therapists[a].urfname.localeCompare(state.entities.admissions[epno].therapists[b].urfname) === 0 ?
        state.entities.admissions[epno].therapists[a].urlname.localeCompare(state.entities.admissions[epno].therapists[b].urlname) :
        state.entities.admissions[epno].therapists[a].urfname.localeCompare(state.entities.admissions[epno].therapists[b].urfname);
        return val;
    })
    .map(key => (
        {
            id: state.entities.admissions[epno].therapists[key].THNO,
            value: state.entities.admissions[epno].therapists[key].urfname + ' ' + state.entities.admissions[epno].therapists[key].urlname,
            URNO: state.entities.admissions[epno].therapists[key].THURNO
        }
    )) : null;

    return {
        supvOptions ,
        epno
    };
}

const connectedPatientHomeAdmissionStartNoteScribe = connect(mapStateToProps, mapDispatchToProps)(PatientHomeAdmissionStartNoteScribe);
export { connectedPatientHomeAdmissionStartNoteScribe as PatientHomeAdmissionStartNoteScribe };

